export default "__VITE_ASSET__1b8cc11f__"